// src/services/inventory.service.js
import { http } from '../lib/http';
import { getUser } from '../lib/authToken';
import { DEV_USER } from '../config/localAuth';

// PUT (update stock for a single item)
export function updateStock(itemId, stockData, { orgId, location }) {
  const user = getUser() || DEV_USER;
  orgId = orgId || user.restaurant_id;
  location = location || user.location;
  const qs = new URLSearchParams({ orgId: String(orgId), location });
  const body = {
    item_id: itemId,
    ...stockData,
  };
  return http.put(`/inventory/update?${qs.toString()}`, body);
}

// Bulk update stock for multiple items
export function bulkUpdateStock(stockDataArray, { orgId, location }) {
  const user = getUser() || DEV_USER;
  orgId = orgId || user.restaurant_id;
  location = location || user.location;
  const qs = new URLSearchParams({ orgId: String(orgId), location });
  const body = stockDataArray;
  return http.put(`/inventory/bulk-update?${qs.toString()}`, body);
}


